import { render, staticRenderFns } from "./ExpensesImportWork.vue?vue&type=template&id=0b15e2d6&scoped=true&lang=pug"
import script from "./ExpensesImportWork.vue?vue&type=script&lang=js"
export * from "./ExpensesImportWork.vue?vue&type=script&lang=js"
import style0 from "./ExpensesImportWork.vue?vue&type=style&index=0&id=0b15e2d6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b15e2d6",
  null
  
)

export default component.exports